var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isBeforeLivestreamStarts
    ? _c(
        "div",
        {
          staticClass: "bandana-v7-teaser position-relative",
          staticStyle: {
            background:
              "repeat center center url('https://img.fortawesome.com/1ce05b4b/tablecloth-pattern3.png'), linear-gradient(135deg, var(--fa-yellow), var(--fa-dk-yellow))",
            "box-shadow": "0 0 5px 5px var(--fa-dk-gravy-transparent2) inset",
            overflow: "hidden",
          },
        },
        [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row roomy" }, [
              _vm.hasBeenCollapsed
                ? _c(
                    "div",
                    {
                      staticClass:
                        "column-12 padding-y-xl padding-x-0 margin-left-xl tablet:margin-left-0",
                    },
                    [
                      _c("div", { staticClass: "text-center" }, [
                        _c(
                          "h2",
                          { staticClass: "h4 margin-top-0 margin-bottom-3xs" },
                          [_vm._v("We're changing the recipe...")]
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass:
                              "padding-right-2xl tablet:padding-right-0",
                          },
                          [
                            _vm._v(
                              "\n            Join us for a special livestream event on\n            "
                            ),
                            _c(
                              "a",
                              {
                                staticStyle: {
                                  "--link-color": "var(--fa-navy)",
                                  "--link-hover-color": "var(--fa-dk-blue)",
                                },
                                attrs: {
                                  href: "/files/Font-Awesome-Special-Announcement.ics",
                                  download: "",
                                  "aria-label": "Download calendar invite!",
                                  "data-balloon-pos": "up",
                                },
                              },
                              [
                                _c("strong", [
                                  _c(
                                    "time",
                                    { attrs: { datetime: `${_vm.endtime}` } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.formatDate(_vm.endtime))
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticStyle: {
                                  "--link-color": "var(--fa-navy)",
                                  "--link-hover-color": "var(--fa-dk-blue)",
                                },
                                attrs: {
                                  target: "_blank",
                                  href: "https://calendar.google.com/calendar/render?action=TEMPLATE&text=Font+Awesome+Special+Announcement&dates=20250402T170000Z/20250402T173000Z&details=Join+us+for+a+special+announcement+on+fontawesome.com%21&location=https%3A%2F%2Ffontawesome.com",
                                  "aria-label": "Add to Google calendar!",
                                  "data-balloon-pos": "up",
                                },
                              },
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "margin-x-4xs",
                                  attrs: {
                                    icon: _vm.$v6.solid
                                      .faArrowUpRightFromSquare,
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(
                              "\n            and see what we've got cooking!\n          "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  )
                : _c(
                    "div",
                    {
                      staticClass:
                        "column-12 text-center padding-y-8xl tablet:padding-y-4xl position-relative",
                    },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _vm._m(1),
                      _vm._v(" "),
                      _vm._m(2),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "position-relative z-2" },
                        [
                          _c("font-awesome-icon", {
                            attrs: {
                              icon: _vm.$v6.brands.faFontAwesome,
                              size: "3x",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "h2",
                            {
                              staticClass: "h3 margin-top-xl margin-bottom-md",
                            },
                            [_vm._v("We're changing the recipe...")]
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticStyle: {
                                "--paragraph-margin-bottom":
                                  "var(--spacing-xl)",
                                "line-height": "1.5",
                              },
                            },
                            [
                              _vm._v(
                                "\n            Join us for a special livestream event on"
                              ),
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticStyle: {
                                    "--link-color": "var(--fa-navy)",
                                    "--link-hover-color": "var(--fa-dk-blue)",
                                  },
                                  attrs: {
                                    href: "/files/Font-Awesome-Special-Announcement.ics",
                                    download: "",
                                    "aria-label": "Download calendar invite!",
                                    "data-balloon-pos": "up",
                                  },
                                },
                                [
                                  _c("strong", [
                                    _c(
                                      "time",
                                      { attrs: { datetime: `${_vm.endtime}` } },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.formatDate(_vm.endtime))
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  staticStyle: {
                                    "--link-color": "var(--fa-navy)",
                                    "--link-hover-color": "var(--fa-dk-blue)",
                                  },
                                  attrs: {
                                    target: "_blank",
                                    href: "https://calendar.google.com/calendar/render?action=TEMPLATE&text=Font+Awesome+Special+Announcement&dates=20250402T170000Z/20250402T173000Z&details=Join+us+for+a+special+announcement+on+fontawesome.com%21&location=https%3A%2F%2Ffontawesome.com",
                                    "aria-label": "Add to Google calendar",
                                    "data-balloon-pos": "up",
                                  },
                                },
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "margin-left-2xs",
                                    attrs: {
                                      icon: _vm.$v6.solid
                                        .faArrowUpRightFromSquare,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("br"),
                              _vm._v(
                                "and see what we've got cooking!\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "countdown display-flex align-center",
                              staticStyle: {
                                gap: "var(--spacing-sm)",
                                "--card-margin-bottom": "var(--spacing-xs)",
                                "--border-color": "var(--fa-dk-yellow)",
                                "--card-vertical-padding": "var(--spacing-md)",
                                "--card-horizontal-padding":
                                  "var(--spacing-lg)",
                                "--tag-background": "transparent",
                                "--tag-padding": "0",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "display-flex flex-column" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "card with-border",
                                      staticStyle: {
                                        "min-width": "var(--spacing-5xl)",
                                      },
                                    },
                                    [
                                      _c(
                                        "strong",
                                        {
                                          staticStyle: {
                                            "font-size": "var(--font-size-lg)",
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.days))]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "tag" }, [
                                    _vm._v(
                                      _vm._s(_vm.formatPlural(_vm.days, "day"))
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "display-flex flex-column" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "card with-border",
                                      staticStyle: {
                                        "min-width": "var(--spacing-5xl)",
                                      },
                                    },
                                    [
                                      _c(
                                        "strong",
                                        {
                                          staticStyle: {
                                            "font-size": "var(--font-size-lg)",
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.hours))]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "tag" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatPlural(_vm.hours, "hour")
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "display-flex flex-column" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "card with-border",
                                      staticStyle: {
                                        "min-width": "var(--spacing-5xl)",
                                      },
                                    },
                                    [
                                      _c(
                                        "strong",
                                        {
                                          staticStyle: {
                                            "font-size": "var(--font-size-lg)",
                                          },
                                        },
                                        [_vm._v(_vm._s(_vm.minutes))]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "tag" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.formatPlural(_vm.minutes, "minute")
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "position-absolute top-md",
                  staticStyle: { right: "var(--spacing-3xl)" },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "close margin-top-0 flat link",
                      staticStyle: {
                        "--link-color": "var(--fa-navy)",
                        "--button-padding": "var(--spacing-sm)",
                      },
                      attrs: {
                        "aria-label": _vm.toggleBandanaLabel,
                        "data-balloon-pos": "left",
                      },
                      on: { click: _vm.toggleBandana },
                    },
                    [
                      _c("font-awesome-icon", {
                        class: [{ "fa-rotate-180": !_vm.hasBeenCollapsed }],
                        attrs: { icon: _vm.$v6.solid.faAngleDown, size: "lg" },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pancakes position-absolute z-1" }, [
      _c("img", {
        attrs: {
          src: "https://img.fortawesome.com/1ce05b4b/pancakes2.png",
          alt: "illustration of pancakes",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "coffee position-absolute z-1" }, [
      _c("img", {
        attrs: {
          src: "https://img.fortawesome.com/1ce05b4b/coffee2.png",
          alt: "illustration of coffee in a diner mug",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "menu position-absolute z-1" }, [
      _c("img", {
        attrs: {
          src: "https://img.fortawesome.com/1ce05b4b/menu2.png",
          alt: "illustration of a diner menu that says Serving Fresh Icons Since 2012",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }